var _mask, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgpGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    masktype: "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V24H40V0Z",
    fill: "#ED2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12H0V24H40V12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7193 5.99962C13.7193 7.19641 13.1911 8.34418 12.2508 9.19044C11.3105 10.0367 10.0352 10.5121 8.70542 10.5121C7.37565 10.5121 6.10035 10.0367 5.16006 9.19044C4.21978 8.34418 3.69153 7.19641 3.69153 5.99962C3.69153 4.80283 4.21978 3.65506 5.16006 2.8088C6.10035 1.96254 7.37565 1.48712 8.70542 1.48712C10.0352 1.48712 11.3105 1.96254 12.2508 2.8088C13.1911 3.65506 13.7193 4.80283 13.7193 5.99962Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2947 5.99999C15.2947 7.131 14.7955 8.21568 13.9069 9.01542C13.0183 9.81516 11.8131 10.2645 10.5564 10.2645C9.29973 10.2645 8.09453 9.81516 7.20593 9.01542C6.31733 8.21568 5.81812 7.131 5.81812 5.99999C5.81812 4.86899 6.31733 3.78431 7.20593 2.98457C8.09453 2.18482 9.29973 1.73553 10.5564 1.73553C11.8131 1.73553 13.0183 2.18482 13.9069 2.98457C14.7955 3.78431 15.2947 4.86899 15.2947 5.99999Z",
    fill: "#ED2939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32591 6.10825L8.64479 5.638L7.96385 6.10847L8.22601 5.35019L7.54272 4.88276L8.38586 4.88436L8.64452 4.125L8.90345 4.88428L9.74658 4.8824L9.06347 5.35005L9.32591 6.10825Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "saturation"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3101 24H0.689685C0.308827 24 0 23.7172 0 23.3684V0.631607C0 0.282821 0.308827 0 0.689685 0H39.3102C39.6911 0 39.9999 0.282821 39.9999 0.631607V23.3684C39.9998 23.7173 39.691 24 39.3101 24Z",
    fill: "#505050"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgpGs);
export default __webpack_public_path__ + "static/media/SGP-gs.93b1d822c7073fd92d523008a91e1cbe.svg";
export { ForwardRef as ReactComponent };